import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import { useReport } from '../../DataStore/ReportContext';

const WeeklyRevenue = () => {
  const { getWeeklyIncomeGraph, weeklyIncomeGraph } = useReport();

  useEffect(() => {
    getWeeklyIncomeGraph();
  }, []);

  const incomeData = Array.isArray(weeklyIncomeGraph)
    ? weeklyIncomeGraph.find(series => series.name === 'Income')
    : { name: 'Income', data: [] };


  const chartData = {
    series: [incomeData],
    options: {
      chart: {
        type: 'bar',
        height: '100%',
        toolbar: { show: true },
        zoom: { enabled: false }
      },
      plotOptions: {
        bar: {
          borderRadius: 6,
          horizontal: false,
          columnWidth: '45%',
          endingShape: 'rounded'
        }
      },
      dataLabels: {
        enabled: false
      },
      xaxis: {
        categories: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
        labels: {
          style: { colors: '#6c757d', fontSize: '12px' }
        }
      },
      yaxis: {
        labels: {
          style: { colors: '#6c757d', fontSize: '12px' }
        }
      },
      fill: {
        opacity: 1
      },
      colors: ['#51d28c', '#f76c6c'],
      tooltip: {
        theme: 'light'
      }
    }
  };

  return (
    <div className="main-card mb-0 card">
      <div className="card-header">
        <div>
          <h5 className="menu-header-title card-title mb-0">Revenue Analytics</h5>
        </div>
      </div>
      <div className="card-body p-0">
        {Array.isArray(weeklyIncomeGraph) &&<Chart 
          options={chartData.options} 
          series={chartData.series} 
          type="bar" 
          height="155" 
          width="100%" 
        />}
        {!weeklyIncomeGraph && <div className="text-center py-4">Loading...</div>}
      </div>
    </div>
  );
};

export default WeeklyRevenue;
